module.exports = __webpack_public_path__ + "img/doctor-circle.467543e3.png";